<script setup lang="ts">
import DownloadAppQrCode from '@features/apps/components/DownloadApp/DownloadAppQrCode.vue'
import DownloadCtaButton from '@features/apps/components/DownloadCtaButton/DownloadCtaButton.vue'

import imageGoogleBadge from '@features/apps/assets/app-google-badge.svg'
import imageStoreBadge from '@features/apps/assets/app-store-badge.svg'
import { useDownloadTracking } from '@features/apps/composables/useDownloadTracking'
import { STORE_DIRECT_LINKS } from '@features/apps/constants'
import { useResponsive } from '@shared/nuxt/useResponsive'

type DownloadLink = {
  id: number
  href: string
  icon: string
  alt: string
  title: string
  track: () => void
}

const { isMobile } = useResponsive()
const { trackStoreApple, trackStoreGoogle } = useDownloadTracking()

const links: DownloadLink[] = [
  {
    id: 1,
    href: STORE_DIRECT_LINKS.apple.href,
    icon: imageStoreBadge,
    alt: STORE_DIRECT_LINKS.apple.alt,
    title: STORE_DIRECT_LINKS.apple.title,
    track: trackStoreApple,
  },
  {
    id: 2,
    href: STORE_DIRECT_LINKS.google.href,
    icon: imageGoogleBadge,
    alt: STORE_DIRECT_LINKS.google.alt,
    title: STORE_DIRECT_LINKS.google.title,
    track: trackStoreGoogle,
  },
]
</script>

<template>
  <div class="download-application" data-test-id="download-app">
    <template v-if="!isMobile">
      <div class="download-application__text-block" data-test-id="text-block">
        <h2 class="download-application__title">
          Скачать
          <br />
          приложение
        </h2>

        <div class="download-application__text">
          Просто наведите камеру телефона
          <br />
          на QR-код и перейдите по ссылке
        </div>

        <div class="download-application__links">
          <the-button
            v-for="link in links"
            :key="link.id"
            :href="link.href"
            :title="link.title"
            class="download-application__link"
            rel="nofollow"
            target="_blank"
            variant="transparent"
            data-test-id="app-link"
            @click="link.track()"
          >
            <nuxt-img
              width="128"
              height="40"
              :src="link.icon"
              :alt="link.alt"
            />
          </the-button>
        </div>
      </div>

      <download-app-qr-code class="download-application__qr-code" />
    </template>

    <div v-else class="download-application__download-button">
      <download-cta-button data-test-id="download-button" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.download-application {
  display: flex;
  gap: 91px;
  height: max-content;
  color: var(--ui-color-supporting-01);

  &__title {
    margin-bottom: 20px;
    font-size: 40px;
    font-weight: 800;
    line-height: 47px;
  }

  &__text {
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
  }

  &__links {
    display: flex;
    gap: 10px;
    margin-top: 30px;

    .app-button {
      height: max-content;
      min-height: unset;
      padding: 0;
      background-color: transparent !important;
      border-radius: unset;
    }
  }

  &__link {
    width: 128px;
  }

  &__qr-code {
    flex-shrink: 0;
  }

  &__download-button {
    width: 100%;
  }
}
</style>
